// extracted by mini-css-extract-plugin
module.exports = {"menuIcon":"menu_menuIcon__16mL2","menu":"menu_menu__2puF1"};